/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import {
  Modal, Icon, Popup, TextArea, Form, Input
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { Scrollbars } from 'react-custom-scrollbars-2';
import $ from 'jquery';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import { convertPropertiesToCamelCase } from '../../utils/shared';

class ScanInfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMSI: props.isOpenMSI,
      //reportId: props.reportId,
      uploadedFile: {},
      project: {},
      versions: {},
      scanOptions: {},
      isLoading: false,
      errorCode: null,
    };
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.modal_popup_wrap .modal_popup .title  span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isOpenMSI, reportId } = this.props;
    if (prevProps.isOpenMSI !== isOpenMSI) {
      this.setState({
        isOpenMSI,
      }, () => {
        if (isOpenMSI) {
          this.getInfoItem(reportId);
        }
      });
    }
  }

  componentWillUnmount() {
  }

  getInfoItem = (id) => {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getResultsByReport(id)
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);
          this.setState({
            isLoading: false,
            //id: data.id,
            uploadedFile: data.uploadedFile,
            project: data.project,
            versions: data.versions,
            errorCode: data.errorCode,
            scanOptions: data.scanOption,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  closeModal(e) {
    const { closeModal } = this.props;
    e.preventDefault();
    closeModal();
  }

  renderBooleanToString(value) {
    const { translate } = this.props;
    let string;
    if (value) {
      string = translate('modal.title.active');
    } else {
      string = translate('modal.title.inactive');
    }

    return <Input value={string} readOnly />;
  }

  renderScanOptionItem(options, item) {
    if (Array.isArray(options[item])) {
      return (
        <Form.Field key={uuidv4()}>
          <label>{item}</label>
          <Input value={options[item].join(', ')} readOnly />
        </Form.Field>
      );
    }
    return (
      <Form.Field key={uuidv4()}>
        <label>{item}</label>
        {
          (typeof options[item] === 'boolean' || options[item] instanceof Boolean) ? (
            this.renderBooleanToString(options[item])
          ) : (
            <Input value={options[item].replace(':', ', ')} readOnly />
          )
        }
      </Form.Field>
    );
  }

  render() {
    const {
      isLoading,
      uploadedFile,
      project,
      versions,
      errorCode,
      scanOptions,
      isOpenMSI,
    } = this.state;

    const { translate } = this.props;

    const tooltipStyle = {
      fontSize: '11px',
      fontWeight: '500',
    };

    const getModalContent = () => {
      if (isLoading) {
        return (
          <div className="modal_popup_wrap move_file_wrap">
            <div className="modal_popup_box move_file_box">
              <div className="modal_popup move_file">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader />
                </div>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className="modal_popup_wrap file_info_wrap">
          <div className="modal_popup_box file_info_box">
            <div className="modal_popup file_info">
              <Form>
                <h2
                  className="title"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                    <Icon className="file outline" style={{ width: '16px', flexShrink: 0, marginRight: '10px' }} />
                    <span
                      style={{
                        flexGrow: 1,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        marginRight: '10px',
                        minWidth: '0',
                      }}
                    >
                      {uploadedFile.name}
                    </span>
                    <span>
                      {
                        uploadedFile.precision_level === 'narrow'
                      && (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="arrow alternate circle up"
                                color="green"
                                style={{ width: '16px', flexShrink: 0 }}
                              />
                            </a>
                          )}
                          content={translate('modal.content.precision_level_narrow')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      )
                      }
                      {
                        uploadedFile.precision_level === 'medium'
                      && (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="exchange"
                                color="blue"
                                style={{ width: '16px', flexShrink: 0 }}
                              />
                            </a>
                          )}
                          content={translate('modal.content.precision_level_medium')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      )
                      }
                      {
                        uploadedFile.precision_level === 'broad'
                      && (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="arrow alternate circle down"
                                color="red"
                                style={{ width: '16px', flexShrink: 0 }}
                              />
                            </a>
                          )}
                          content={translate('modal.content.precision_level_broad')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      )
                      }
                    </span>
                  </div>
                  <a className="close_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    <img src={closeBtn} alt="" />
                  </a>
                </h2>
                <Scrollbars
                  renderTrackHorizontal={() => {
                    return <div />;
                  }}
                  renderThumbHorizontal={() => {
                    return <div />;
                  }}
                  autoHeight
                  autoHeightMin={350}
                  autoHeightMax={350}
                >
                  <div className="popup_content">
                    {
                      errorCode !== null
                      && (
                        <Form.Field>
                          <TextArea className="error_info" value={errorCode} readOnly />
                        </Form.Field>
                      )
                    }
                    <Form.Field>
                      <label>{translate('modal.scan_info.completed')}</label>
                      <Input value={uploadedFile.completed_at} readOnly />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.scan_info.uploaded_size')}</label>
                      <Input value={uploadedFile.uploaded_size} readOnly />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.scan_info.scanned_size')}</label>
                      <Input value={uploadedFile.scaned_size} readOnly />
                    </Form.Field>
                    <div className="line" />
                    <Form.Field>
                      <label>{translate('modal.scan_info.project_name')}</label>
                      <Input value={project.name} readOnly />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.scan_info.project_version')}</label>
                      <Input value={project.version} readOnly />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.scan_info.owner')}</label>
                      <Input value={project.owner} readOnly />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.scan_info.description')}</label>
                      <TextArea value={project.description} readOnly />
                    </Form.Field>
                    <div className="line" />
                    <Form.Field>
                      <label>{translate('modal.scan_info.clarity_version')}</label>
                      <Input value={versions.clarity} readOnly />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.scan_info.oss_db_version')}</label>
                      <Input value={versions.oss} readOnly />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.scan_info.security_db_version')}</label>
                      <Input value={versions.cve} readOnly />
                    </Form.Field>
                    <div className="line" />
                    {
                      typeof Object.keys(scanOptions) !== 'undefined' && Object.keys(scanOptions).length !== 0
                      && (
                        <Form.Group grouped>
                          <label>{translate('modal.scan_info.scan_option')}</label>
                          {
                            Object.keys(scanOptions).map((item) => {
                              return this.renderScanOptionItem(scanOptions, item);
                            })
                          }
                        </Form.Group>
                      )
                    }
                  </div>
                </Scrollbars>
              </Form>
              <div className="button_wrap">
                <a onClick={this.closeModal} onKeyUp={this.closeModal} className="center_button">{translate('modal.button.close')}</a>
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (
      <Modal open={isOpenMSI} onClose={this.closeModal}>
        {getModalContent()}
      </Modal>
    );
  }
}

export default ScanInfoModal;
